import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'checkElementProperty' })
export class CheckElementPropertyPipe implements PipeTransform {

  transform(element: HTMLElement, key: string, type: "class" | "property", value = false): boolean | string {
    switch (type) {
      case "class": return element.classList.value.includes(key);
    }
    return false;
  }

}
